type ConsentStatus = "granted" | "denied";

interface ConsentParams {
  analytics_storage: ConsentStatus;
  ad_storage: ConsentStatus;
  ad_user_data: ConsentStatus;
  ad_personalization: ConsentStatus;
}

export const updateConsent = (granted: boolean): void => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  const status: ConsentStatus = granted ? "granted" : "denied";
  const params: ConsentParams = {
    analytics_storage: status,
    ad_storage: status,
    ad_user_data: status,
    ad_personalization: status,
  };
  window.gtag("consent", "update", params);
};

export const pushDataLayerEvent = (
  event: string,
  data?: Record<string, unknown>
): void => {
  if (typeof window === "undefined") {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
};
